import classnames from 'classnames';
import { graphql } from 'gatsby';
import { Text, TextColor, TextVariant } from 'hem-ui';
import get from 'lodash/get';
import React from 'react';

import { center, root } from './RichTextPressQuote.module.scss';

export const RichTextPressQuote: React.FC<{
  node: { data: { target: Queries.RichTextPressQuoteFragment } };
}> = ({ node }): JSX.Element => {
  const entry = get(node, 'data.target');

  if (!entry) {
    console.warn('[RichTextButton] Entry not rendered', { node });
    return null;
  }

  const domain = new URL(entry.buttonLink).hostname.replace('www.', '');

  return (
    <div className={classnames(root, { [center]: entry.quote.length < 40 })}>
      <blockquote>
        <Text tag="p" variant={TextVariant.HEADLINE_SMALL}>
          “{entry.quote}”
        </Text>
        <cite>
          <Text
            tag="a"
            href={entry.buttonLink}
            variant={TextVariant.BODY_SMALL}
            color={TextColor.BLACK}
          >
            {entry.buttonText}
            <br />
            <Text variant={TextVariant.BODY_SMALL} color={TextColor.GRAY_DARK}>
              {domain}
            </Text>
          </Text>
        </cite>
      </blockquote>
    </div>
  );
};

export const query = graphql`
  fragment RichTextPressQuote on ContentfulComponentPressQuote {
    __typename
    contentful_id
    quote
    buttonLink
    buttonText
  }
`;
